import React, { Component } from 'react'
import moment from 'moment'
import { Droppable, Draggable } from 'react-beautiful-dnd';
//functions
import { hexToRgba } from '../../../../functions/general/general'
//images
import Lock from '../../../../images/updatepopup/openLock.svg'
import DragIcon from '../../../../images/general/drag_icon.svg'
import WarningIcon from '../../../../images/general/warning-sign.svg'
//icons
import { sortProcessesWeeklyView } from '../../../../functions/data/sortProcesses'
import { createOrderProcessBackground } from '../../../../functions/helpers/createOrderProcessBackground'
import { InformationPopup } from '../../../updatePopups/InformationPopup';
import { getPosition } from '../../../../hooks/helper';
import caretLeft from '../../../../images/general/caret-left.svg'
import caretRight from '../../../../images/general/caret-right.svg'
import ParallelProcessIcon from '../../../../images/updatepopup/parallel.svg'
import { InfoTooltip } from "../../../generals/infoTooltip";

let uniqid = require("uniqid");

class WeeklyCalendar extends Component {

    constructor() {
        super()

        this.state = {
            holidays: []
        }
    }

    shouldComponentUpdate(_np, _ns) {
        let _p = this.props; let _s = this.state;
        return (
            _np.currentSelectedDate !== _p.currentSelectedDate
            || _np.weeklyOrders !== _p.weeklyOrders
            || _np.daysArray !== _p.daysArray
            || _ns !== _s
        ) ? true : false;
    }

    openUpdateMenu = (process) => {
        this.props.openUpdateMenu(process)
    }

    componentDidMount() {
        const { daysArray } = this.props
        let holidays = []
        daysArray.map(item => {
            if (item.holidays.length > 0 && item.holidays[0].status !== "Half Day" || item.offDay) {
                let holidayDayIndex = moment(item.date).day()
                holidays.push(holidayDayIndex)
            }
        })

        this.setState({ holidays })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.daysArray[0].date !== this.props.daysArray[0].date) {
            let holidays = []
            this.props.daysArray.map(item => {
                if (item.holidays.length > 0 && item.holidays[0].status !== "Half Day" || item.offDay) {
                    let holidayDayIndex = moment(item.date).day()
                    holidays.push(holidayDayIndex)
                }
            })

            this.setState({ holidays })

        }
    }

    backToToday = () => {
        this.props.backToToday()
    }

    setDayColor = (day) => {
        const { weeklyOrders } = this.props
        const warning = weeklyOrders.reduce((result, order) => {
            const { processes } = order
            processes.forEach(processGroup => {
                const warning = processGroup.find(process => process.warnings && moment(process.process_date).isSame(day.date, 'day'))
                if (warning) result = true
            })
            return result
        }, false)

        return warning ? 'red' : '#000000'
    }

    checkWorkloadExceeded = (workload) => {
        const PERCENT_100 = 100
        return workload > PERCENT_100
    }

    previous_info_popup_id = '';
    initHandlerForInfoPopup = (event, popup_id) => {
        if (this.previous_info_popup_id) {
            let tag = this.getElementStyle(this.previous_info_popup_id);
            tag && (tag.display = 'none');;
        }
        if (popup_id) {
            let tag = this.getElementStyle(popup_id);
            tag && (tag.display = 'block');
        }
        if (popup_id) {
            let tag = document.getElementById(popup_id);
            tag && (tag.style.marginTop = this.setInfoTopView(event));
        }
        this.previous_info_popup_id = popup_id;
    };

    setInfoTopView = (event) => {
        let xPoint = event.clientX;
        let yPoint = event.clientY;
        let innerHeight = window.innerHeight;
        let height = innerHeight - yPoint;
        return (height < 160) ? '-48px' : '34px';
    }

    closeHandlerInfoPopup = (event, popup_id) => {
        let is_hover_on_info = false;
        let popup = document.getElementById(popup_id)?.addEventListener('mouseenter', (e) => {
            is_hover_on_info = true;
        }, false);
        setTimeout(() => {
            if (!is_hover_on_info) {
                this.getElementStyle(popup_id).display = 'none';
            }
        }, 100)
    };

    getElementStyle = (_id) => document.getElementById(_id)?.style;

    checkIndexAndSetWidth = (data, index) => {
        const { process_width = 1 } = data || {};
        return data.process_duration ? `calc(((100% + 0.3px) * ${process_width}) - 15px)` : `calc(((100% - 8px)`
    }

    rightAlignment = (data, index) => {
        const { process_width = 1 } = data || {};
        return 100 * (data.process_duration && process_width - 1 > 0 ? process_width - 1 : 0) + "px"
    }

    createDummyProcesses = (weeklyOrders) => {
        weeklyOrders.forEach(order => {
            order.processes.forEach((dayProcesses, dayIndex) => {
                dayProcesses.forEach((process, processIndex) => {
                    if (typeof process.process_width === 'undefined' || process.dummy) {
                        return;
                    }

                    const { process_width } = process;
                    if (process_width > 1) {
                        // Create dummies for consecutive working days only
                        let k = 1;
                        let dummiesCreated = 0;
                        
                        while (dummiesCreated < process_width - 1 && dayIndex + k < order.processes.length) {
                            if (this.isWorkingDay(dayIndex + k)) {
                                this.insertDummyProcessWithoutMovingAlreadyPositionedDummys(
                                    order.processes[dayIndex + k],
                                    processIndex,
                                    {
                                        ...process,
                                        _id: `dummy_${process._id}_${k}`,
                                        dummy: true,
                                    }
                                );
                                dummiesCreated++;
                            } else {
                                // If we hit a non-working day, stop creating dummies for this segment
                                break;
                            }
                            k += 1;
                        }
                    }
                });
            });
        });

        return weeklyOrders;
    }

    insertDummyProcessWithoutMovingAlreadyPositionedDummys = (result, position, elem) => {
        let foundNonF = false;
        let insertionIndex = position;

        while (insertionIndex < result.length && ('dummy' in result[insertionIndex] && result[insertionIndex]['dummy'] && foundNonF === false)) {
            if (!('dummy' in result[insertionIndex] && result[insertionIndex]['dummy'])) {
                foundNonF = true;
                break;
            }
            insertionIndex++;
        }

        if (!foundNonF && insertionIndex === result.length) {
            result.push(elem);
        } else {
            let i = insertionIndex;
            let lastElem = elem;

            while (i < result.length) {
                if ('dummy' in result[i] && result[i]['dummy']) {
                    i++;
                    continue;
                } else {
                    const currentElem = result[i];
                    result[i] = lastElem;
                    lastElem = currentElem;
                    i++;
                }
            }
            result.push(lastElem);
        }
        return result;
    }

    // Helper function to check if a day index is a holiday
    isHoliday = (dayIndex) => {
        if (!this.state.holidays || !Array.isArray(this.state.holidays)) {
            return false;
        }

        return this.state.holidays.includes(dayIndex);
    }

    // Helper function to check if a day index is a weekend (Friday=5, Saturday=6)
    isWeekend = (dayIndex) => {
        return dayIndex === 5 || dayIndex === 6; // Friday and Saturday
    }

    // Helper function to check if a day index is a working day
    isWorkingDay = (dayIndex) => {
        return !this.isWeekend(dayIndex) && !this.isHoliday(dayIndex);
    }

    // Enhanced checkIfHolidayOrDayOff function (combines weekend and holiday checks)
    checkIfHolidayOrDayOff = (dayIndex) => {
        return this.isWeekend(dayIndex) || this.isHoliday(dayIndex);
    }

    // Helper function to get next working day index
    getNextWorkingDayIndex = (currentDayIndex) => {
        let nextDayIndex = (currentDayIndex + 1) % 7;

        // Keep looking for next working day
        while (!this.isWorkingDay(nextDayIndex)) {
            nextDayIndex = (nextDayIndex + 1) % 7;

            // Prevent infinite loop (though unlikely)
            if (nextDayIndex === currentDayIndex) {
                break;
            }
        }

        return nextDayIndex;
    }

    // Function to calculate how many consecutive working days we can fit starting from a day
    calculateContinuousProcessWidth = (startDayIndex, processDuration) => {
        let currentDayIndex = startDayIndex;
        let workingDaysFound = 0;
        let totalDaysSpanned = 0;

        // Count consecutive working days from start position
        while (workingDaysFound < processDuration && currentDayIndex < 7) {
            if (this.isWorkingDay(currentDayIndex)) {
                workingDaysFound++;
            } else {
                // If we hit a non-working day, break the sequence
                break;
            }
            totalDaysSpanned++;
            currentDayIndex++;
        }

        return workingDaysFound;
    }

    // Function to find all segments of a process split by non-working days
    findProcessSegments = (startDayIndex, totalWorkingDays) => {
        const segments = [];
        let currentDayIndex = startDayIndex;
        let remainingWorkingDays = totalWorkingDays;

        while (remainingWorkingDays > 0 && currentDayIndex < 7) {
            // Skip to next working day
            while (currentDayIndex < 7 && !this.isWorkingDay(currentDayIndex)) {
                currentDayIndex++;
            }

            if (currentDayIndex >= 7) break;

            // Count consecutive working days for this segment
            let segmentStart = currentDayIndex;
            let segmentWorkingDays = 0;

            while (currentDayIndex < 7 && this.isWorkingDay(currentDayIndex) && remainingWorkingDays > 0) {
                segmentWorkingDays++;
                remainingWorkingDays--;
                currentDayIndex++;
            }

            if (segmentWorkingDays > 0) {
                segments.push({
                    startDayIndex: segmentStart,
                    workingDays: segmentWorkingDays
                });
            }
        }

        return segments;
    }

    transformWeeklyOrders = (weeklyOrders) => {
        const { daysArray } = this.props;
        const orderProcessMap = {};
        const processedIds = new Set(); // Track processed process IDs to prevent duplicates

        // Create a deep copy to avoid mutating original data
        let transformedOrders = JSON.parse(JSON.stringify(weeklyOrders));

        // Build process map with start/end dates
        transformedOrders.forEach(order => {
            order.processes.forEach((dayProcesses, dayIndex) => {
                dayProcesses.forEach(process => {
                    if (typeof process.process_date === 'undefined' || typeof process.process_endDate === 'undefined') {
                        return;
                    }

                    const { process_date, process_endDate, process_id } = process;
                    const id = `${process.order_id || order._id}_${process_id}`;

                    if (id in orderProcessMap) {
                        const { start, end } = orderProcessMap[id];
                        if (moment(process_date).isBefore(start)) {
                            orderProcessMap[id].start = process_date;
                        }
                        if (moment(process_endDate).isAfter(end)) {
                            orderProcessMap[id].end = process_endDate;
                        }
                    } else {
                        orderProcessMap[id] = {
                            start: process_date,
                            end: process_endDate,
                        };
                    }
                });
            });
        });

        // Remove duplicates and calculate process widths with proper segmentation
        const checkedInDataMap = {};
        const additionalSegments = []; // Store additional segments to add later

        transformedOrders.forEach(order => {
            order.processes.forEach((dayProcesses, dayIndex) => {
                // Skip processing if current day is not a working day
                if (!this.isWorkingDay(dayIndex)) {
                    // Remove any processes that shouldn't be on non-working days
                    for (let j = dayProcesses.length - 1; j >= 0; j--) {
                        const process = dayProcesses[j];
                        if (!process.dummy && !process.allowOnNonWorkingDays) {
                            dayProcesses.splice(j, 1);
                        }
                    }
                    return;
                }

                for (let j = dayProcesses.length - 1; j >= 0; j--) {
                    const process = dayProcesses[j];

                    if (typeof process.process_date === 'undefined' || typeof process.process_id === 'undefined') {
                        continue;
                    }

                    const { process_id } = process;
                    const id = `${process.order_id || order._id}_${process_id}`;

                    // Skip if already processed (prevents duplicates)
                    if (processedIds.has(id)) {
                        dayProcesses.splice(j, 1);
                        continue;
                    }

                    if ((id in checkedInDataMap) && !process.skipForCheckedinCheck) {
                        dayProcesses.splice(j, 1);
                    } else if ((id in checkedInDataMap) && process.skipForCheckedinCheck) {
                        continue;
                    } else {
                        checkedInDataMap[id] = true;
                        processedIds.add(id); // Mark as processed
                        const startEndData = orderProcessMap[id];

                        if (startEndData) {
                            const { start, end } = startEndData;
                            const startDate = moment(start).startOf('day');
                            const endDate = moment(end).startOf('day');

                            // You already have daysArray like: [{ parsedDate: '21/09/2025' }, ...]
                            const datesArray = this.props.daysArray.map(item => item.parsedDate); // ['21/09/2025', ..., '25/09/2025']
                            const weekDatesSet = new Set(datesArray.map(d => moment(d, 'DD/MM/YYYY').format('YYYY-MM-DD')));

                            let totalWorkingDays = 0;
                            let totalWorkingDaysInWeek = 0;

                            let currentDate = moment(startDate);

                            while (currentDate.isSameOrBefore(endDate)) {
                                const dayOfWeek = currentDate.day();
                                const isWorkingDay = this.isWorkingDay(dayOfWeek);

                                if (isWorkingDay) {
                                    totalWorkingDays++;

                                    const currentDateStr = currentDate.format('YYYY-MM-DD');
                                    if (weekDatesSet.has(currentDateStr)) {
                                        totalWorkingDaysInWeek++;
                                    }
                                }

                                currentDate.add(1, 'day');
                            }

                            // Set values to process
                            process.totalWorkingDays = totalWorkingDays;
                            process.totalWorkingDaysInWeek = totalWorkingDaysInWeek;
                            process.perDayQuantity = process.quantity * totalWorkingDaysInWeek;
                            // Find all segments for this process
                            const segments = this.findProcessSegments(dayIndex, totalWorkingDays);

                            if (segments.length > 0) {
                                // Set the first segment's width for current process
                                process.process_width = segments[0].workingDays;
                                
                                // Store additional segments for later placement
                                for (let segIndex = 1; segIndex < segments.length; segIndex++) {
                                    const segment = segments[segIndex];
                                    additionalSegments.push({
                                        orderIndex: transformedOrders.indexOf(order),
                                        dayIndex: segment.startDayIndex,
                                        process: {
                                            ...process,
                                            _id: `${process._id}_segment_${segIndex}`,
                                            process_width: segment.workingDays,
                                            isSegment: true,
                                            originalProcessId: process._id,
                                            segmentIndex: segIndex,
                                            totalSegments: segments.length
                                        }
                                    });
                                }

                                // Mark if process has multiple segments
                                if (segments.length > 1) {
                                    process.hasMultipleSegments = true;
                                    process.totalSegments = segments.length;
                                    process.segmentIndex = 0;
                                }
                            } else {
                                // Fallback - set minimum width
                                process.process_width = 1;
                            }

                            // Ensure minimum width of 1 for valid processes
                            if (process.process_width < 1) {
                                process.process_width = 1;
                            }
                        }
                    }
                }
            });
        });

        // Add additional segments to their respective days
        additionalSegments.forEach(({ orderIndex, dayIndex, process }) => {
            if (dayIndex < transformedOrders[orderIndex].processes.length) {
                transformedOrders[orderIndex].processes[dayIndex].push(process);
            }
        });

        return this.createDummyProcesses(transformedOrders);
    }

    render() {
        let info_popup_position = {
            initial: -1,
            last: 97,
        };

        const {
            daysArray,
            currentSelectedDate,
            weeksDateChange,
            weeklyOrders,
            daysOffNumber,
            disableDrag,
            getMoreDataOnScroll
        } = this.props;

        const validDayCount = daysArray.filter(day =>
            day.holidays.length === 0 || day.holidays.some(holiday =>
                holiday.status === "Half Day"
            )
        ).length;

        let blockDecrementation = false;

        const filteredWeeklyOrders = weeklyOrders.filter(order => {
            const allProcesses = order.processes.flat();
            return allProcesses.length > 0;
        });

        // Transform weekly orders to handle multi-day processes
        const transformedWeeklyOrders = this.transformWeeklyOrders(filteredWeeklyOrders);
        return (
            <div className="week-view-page__calendar">
                <header className="week-view-page__calendar__header">
                    <button className="btn--back--today" onClick={() => { this.backToToday(); }}>
                        <p>חזור להיום</p>
                    </button>
                    <figure
                        className='weekly-arrow-right'
                        style={blockDecrementation ? { pointerEvents: 'none' } : {}}
                        onClick={() => { weeksDateChange('dec'); }}
                    >
                        <img src={caretRight} alt="" />
                    </figure>
                    <h3>
                        <span>שבוע {daysArray && daysArray.length > 0 ? moment(daysArray[0].date).format('w') : ''} &nbsp;</span>
                        <span>( {daysArray && daysArray.length > 0 ? daysArray[0].parsedDate : ''} - {daysArray && daysArray.length > 0 ? daysArray[daysArray.length - 1].parsedDate : ''} )</span>
                    </h3>
                    <figure className='weekly-arrow-left' onClick={() => { weeksDateChange('inc'); }}>
                        <img src={caretLeft} alt="" />
                    </figure>
                </header>

                <section className="week-view-page__calendar__dates">
                    <div className="week-view-page__calendar__dates--sections" style={{ width: `calc( (100% / ${7 - daysOffNumber}) - 0.33334% )` }}>
                        <span>תאריכים</span>
                    </div>
                    <div className="week-view-page__calendar__dates--content">
                        {daysArray && daysArray.length > 0 ?
                            daysArray.map(item => {
                                if (!item.offDay) {
                                    return (
                                        <div
                                            key={uniqid()}
                                            className="week-view-page__calendar__dates--content__day"
                                            style={{ width: `calc( 100% / ${7 - daysOffNumber})` }}
                                        >
                                            <section style={{ color: this.setDayColor(item) }}>
                                                {item.dateName} - {item.parsedDate}
                                            </section>
                                            <section>
                                                {item.offDay ?
                                                    <span>סופ״ש</span>
                                                    : null
                                                }

                                                {item.holidays.length > 0 ?
                                                    <span><p>{item.holidays[0].name}</p></span>
                                                    : null
                                                }
                                            </section>
                                        </div>
                                    );
                                }
                            })
                            : null
                        }
                    </div>
                </section>

                <section className="week-view-page__calendar__data" onScroll={getMoreDataOnScroll}>
                    {transformedWeeklyOrders.length > 0 ?
                        transformedWeeklyOrders.map((item) => {
                            const summedQuantities = item.processes.map(subArray =>
                                subArray.reduce((sum, item) => {
                                    const qty = Number(item.perDayQuantity) / (item.original_process_duration);
                                    const workingQuantitiy = qty / item.totalWorkingDaysInWeek;
                                    return sum + workingQuantitiy;
                                }, 0)
                            );

                            const allProcesses = item.processes.flat(); // flatten the nested arrays
                            const uniqueByProcessAndOrder = new Map();
                            let finished_sum = 0
                            const fractionMap = new Map();
                            let hasFractionFalse = false
                            for (const p of allProcesses) {
                                const key = `${p.process_id}_${p.order_id}`;
                                if (!uniqueByProcessAndOrder.has(key)) {
                                    uniqueByProcessAndOrder.set(key, p);
                                    finished_sum += Number(p.finished) || 0;
                                }
                                if (!fractionMap.has(key)) {
                                    fractionMap.set(key, []);
                                }
                                fractionMap.get(key).push({
                                    _id: p._id,
                                    order_id: p.order_id,
                                    fraction: p.fraction
                                });
                            }
                            for (const processes of fractionMap.values()) {
                                if (!processes.some(proc => proc.fraction === false)) {
                                    hasFractionFalse = true;
                                    break; // no need to check further
                                }
                            }

                            const totalSumFinished = finished_sum
                            const uniqueCount = uniqueByProcessAndOrder.size;
                            const totalSumQuantity = Math.round(summedQuantities.reduce((a, b) => a + b, 0));
                            const totalQuantity = item.process_duration > 0 ? uniqueCount : totalSumQuantity;
                            const sum = Number(item.process_duration + item.process_quantity);
                            const capacity_divider = sum > 0 ? sum : 1;
                            const capacity_per_week = (item.factory_working_hours * validDayCount) / capacity_divider;
                            const quantity_percentage =  Math.floor((100 * totalQuantity) / capacity_per_week)
                            return (
                                <div className="week-view-page__calendar__data__row" key={item._id}>
                                    <div className="week-view-page__calendar__data__row--name" style={{ width: `calc( 100% / ${8 - daysOffNumber})`, position: 'relative', color: (quantity_percentage > 100 ? 'red' : ''), border: (quantity_percentage > 100 ? '1px solid' : '') }}>
                                        <span>
                                            <div className="capacity-per-week" style=
                                            {{
                                                    gap: '10px',
                                                    display: 'flex',
                                                    flexDirection: 'column'
                                            }}>
                                                <p style={this.checkWorkloadExceeded(item.workload_percentage) ? { color: '#ff0000' } : {}}>
                                                    {item.process_name}
                                                </p>
                                                <span className="quantity-number">
                                                    {capacity_per_week} / {totalQuantity}
                                                </span>
                                            </div>
                                            <p style={this.checkWorkloadExceeded(item.workload_percentage) ? { color: '#ff0000' } : {}}>
                                                {item.workload_percentage ? `% ${item.workload_percentage}` : ''}
                                            </p>
                                            
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    left: '10px',
                                                    bottom: '10px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'flex-end', // align left
                                                    gap: '2px'
                                                }}
                                                >
                                                {/* Row 1: Percentage with optional warning */}
                                                <span
                                                    className="quantity-percentage"
                                                    style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    minHeight: '28px'
                                                    }}
                                                >
                                                    {quantity_percentage > 100 && (
                                                    <img
                                                        style={{ width: '20px' }}
                                                        className="warning_icon"
                                                        src={WarningIcon}
                                                        alt="warning"
                                                    />
                                                    )}
                                                    {quantity_percentage}%
                                                </span>

                                                

                                                {/* Row 3: Finished quantities with optional tooltip */}
                                                <span
                                                    className="quantity-number2"
                                                    style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    minHeight: '28px'
                                                    }}
                                                >
                                                    {hasFractionFalse && (
                                                    <InfoTooltip
                                                        message='חישוב סה"כ שהסתיים כולל דיווחים משבוע קודם'
                                                        placement="right"
                                                        size="small"
                                                        color_required={true}
                                                    />
                                                    )}
                                                    {totalSumQuantity} / {totalSumFinished}
                                                </span>
                                            </div>
                                        </span>
                                    </div>
                                    <div className="week-view-page__calendar__data__row--processes">
                                        {item.processes.map((subItem, index) => {
                                            if (this.checkIfHolidayOrDayOff(index) === 'holiday') {
                                                return (
                                                    <div
                                                        key={item.process_name + index}
                                                        className="week-view-page__calendar__data__row--processes__droppable"
                                                        style={{ width: `calc( 100% / ${7 - daysOffNumber})` }}
                                                    />
                                                );
                                            } else {
                                                return (
                                                    <Droppable droppableId={item.process_name + index} key={item.process_name + index}>
                                                        {(provided, snapshot) => (
                                                            <div
                                                                className="week-view-page__calendar__data__row--processes__droppable"
                                                                ref={provided.innerRef}
                                                                {...provided.droppableProps}
                                                                style={{
                                                                    width: `calc( 100% / ${7 - daysOffNumber})`,
                                                                    ...provided.droppableProps.style,
                                                                    background: snapshot.isDraggingOver ? '#e5e5e5' : 'transparent'
                                                                }}
                                                            >
                                                                {sortProcessesWeeklyView(subItem).map((process, subIndex) => {
                                                                    let width = process.finished === '0' ? 0 : (process.finished / process.quantity) * 100 + '%';

                                                                    let resourcesNameString = process.resource.map(subitem => subitem.name + ' / ').join(' ').replace(/,/gi, '');
                                                                    resourcesNameString = resourcesNameString.substr(0, resourcesNameString.length - 2);

                                                                    // Handle dummy processes
                                                                    if (process.dummy) {
                                                                        return (
                                                                            <div
                                                                                key={process._id}
                                                                                style={{
                                                                                    height: '79px',
                                                                                    marginBottom: '5px',
                                                                                }}
                                                                            >
                                                                                {/* Dummy process placeholder */}
                                                                            </div>
                                                                        );
                                                                    }

                                                                    if (!process.backlog) {
                                                                        return (
                                                                            <Draggable
                                                                                draggableId={process._id}
                                                                                index={subIndex}
                                                                                key={process._id}
                                                                                isDragDisabled={disableDrag || process.done || process.fraction}
                                                                            >
                                                                                {(provided) => (
                                                                                    <>
                                                                                        <div
                                                                                            onClick={() => { this.openUpdateMenu(process); }}
                                                                                            className="week-view-page__calendar__data__row--processes__draggable"
                                                                                            {...provided.draggableProps}
                                                                                            {...provided.dragHandleProps}
                                                                                            ref={provided.innerRef}
                                                                                            style={{
                                                                                                zIndex: 99,
                                                                                                width: `calc(((99.5% + 1.3px) * ${process.process_width || 1}) - 5px)`,
                                                                                                position: 'relative',
                                                                                                height: '74px',
                                                                                                alignSelf: 'flex-start',
                                                                                                ...provided.draggableProps.style,
                                                                                                fontSize: '7px',
                                                                                                paddingRight: 5,
                                                                                                paddingLeft: 5
                                                                                            }}
                                                                                        >
                                                                                            <aside
                                                                                                className="week-view-page__calendar__data__row--processes__draggable__progress-bar"
                                                                                                style={{ background: createOrderProcessBackground(process) }}
                                                                                            >
                                                                                            </aside>

                                                                                            <section
                                                                                                className="week-view-page__calendar__data__row--processes__draggable--section1"
                                                                                                onMouseEnter={(event) => this.initHandlerForInfoPopup(event, process._id)}
                                                                                                onMouseLeave={(event) => this.closeHandlerInfoPopup(event, process._id)}
                                                                                            >
                                                                                                <img src={DragIcon} alt="draggable" />
                                                                                            </section>

                                                                                            <section
                                                                                                className="week-view-page__calendar__data__row--processes__draggable--section2"
                                                                                                style={process.done ? { color: '#d6d6d6' } : {}}
                                                                                            >
                                                                                                <p className='number_and_remark_wrapper'>
                                                                                                    <span>{process.order_number}</span>
                                                                                                    <span className='remark_text four_characters_length'>{process.remark}</span>
                                                                                                </p>
                                                                                                <p>{process.client_name}</p>
                                                                                                <p>{resourcesNameString}</p>
                                                                                            </section>

                                                                                            <section className="week-view-page__calendar__data__row--processes__draggable--section3">
                                                                                                {process.is_detached ?
                                                                                                    <div>
                                                                                                        <img src={Lock} alt="menu" />
                                                                                                    </div>
                                                                                                    : null
                                                                                                }
                                                                                                {!process?.is_detached && process?.should_occur_parallel ?
                                                                                                    <img
                                                                                                        style={process?.should_occur_parallel ? { marginBottom: '2px' } : {}}
                                                                                                        className="lock__icon"
                                                                                                        src={ParallelProcessIcon}
                                                                                                        alt="parallel icon"
                                                                                                    />
                                                                                                    : null
                                                                                                }
                                                                                                {process.warnings ?
                                                                                                    <aside></aside>
                                                                                                    : <div style={{ backgroundColor: 'transparent' }}></div>
                                                                                                }

                                                                                                <span style={process.done ? { color: '#d6d6d6' } : { color: hexToRgba(process.color, '1') }}>
                                                                                                    {process.finished + '/' + process.quantity}
                                                                                                </span>
                                                                                            </section>
                                                                                        </div>
                                                                                        <div
                                                                                            style={{
                                                                                                display: 'none',
                                                                                                transform: `translateX(${getPosition(info_popup_position, process.process_date)} - 5%)`,
                                                                                                zIndex: 100000
                                                                                            }}
                                                                                            className="info--popup"
                                                                                            id={process._id}
                                                                                        >
                                                                                            <InformationPopup process={process} popupId={process._id} />
                                                                                        </div>
                                                                                    </>
                                                                                )}
                                                                            </Draggable>
                                                                        );
                                                                    }
                                                                })}
                                                                {provided.placeholder}
                                                            </div>
                                                        )}
                                                    </Droppable>
                                                );
                                            }
                                        })}
                                    </div>
                                </div>
                            );
                        })
                        :
                        [1].map((item, index) => {
                            return (
                                <div key={item} className='week-view-page__calendar__data__row'>
                                    <div className="week-view-page__calendar__data__row--name" style={{ width: `calc(16.59%)` }}>
                                        <span></span>
                                    </div>
                                    {[0, 1, 2, 3, 4].map(_i => {
                                        return (
                                            <Droppable droppableId={`${_i}default`} key={`090${_i}012`}>
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.droppableProps}
                                                        style={{
                                                            height: '100px',
                                                            width: '100%',
                                                            display: 'flex',
                                                            borderBottom: '1px solid darkgray',
                                                            ...provided.droppableProps.style
                                                        }}
                                                    >
                                                    </div>
                                                )}
                                            </Droppable>
                                        );
                                    })}
                                </div>
                            );
                        })
                    }
                </section>
            </div>
        );
    }
}

export default WeeklyCalendar